module.exports = __webpack_public_path__ + "static/img/pickup-singlecab-white.87f418b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-singlecab-white.svg
// module id = tngU
// module chunks = 82